import { render, staticRenderFns } from "./CompanyPendingPaymentWidget.vue?vue&type=template&id=60bacc59"
import script from "./CompanyPendingPaymentWidget.vue?vue&type=script&lang=js"
export * from "./CompanyPendingPaymentWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports